import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddEditArticleModalComponent } from './modals/add-edit-article-modal/add-edit-article-modal.component';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzWaveModule } from 'ng-zorro-antd/core/wave';
import { AddEditArticleFormComponent } from './forms/add-edit-article-form/add-edit-article-form.component';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UiModule } from '../ui/ui.module';
import { CoreModule } from '../core/core.module';
import { StoreStocksCorrectionsModalComponent } from './modals/store-stocks-corrections-modal/store-stocks-corrections-modal.component';
import { StoreStocksCorrectionsListComponent } from './lists/store-stocks-corrections-list/store-stocks-corrections-list.component';
import { NzTooltipDirective } from 'ng-zorro-antd/tooltip';
import { ArticleLabelsModule } from '../pages/article-labels/article-labels.module';
import { ChangeMhdModalComponent } from './modals/change-mhd-modal/change-mhd-modal.component';
import { NzStatisticComponent } from 'ng-zorro-antd/statistic';
import { ArticleSalesHistoryTableComponent } from './lists/article-sales-history-table/article-sales-history-table.component';
import { ArticleSalesForecastComponent } from './lists/article-sales-forecast/article-sales-forecast.component';
import { CoreModule as LabelsPrinterCoreModule } from '../pages/labels-printer/core/core.module';
import { RouterModule } from '@angular/router';
import { RecipeCardFinderComponent } from './lists/recipe-card-finder/recipe-card-finder.component';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { BaseChartDirective, provideCharts, withDefaultRegisterables } from 'ng2-charts';

@NgModule({
  declarations: [
    AddEditArticleModalComponent,
    AddEditArticleFormComponent,
    StoreStocksCorrectionsModalComponent,
    StoreStocksCorrectionsListComponent,
    ChangeMhdModalComponent,
    ArticleSalesHistoryTableComponent,
    ArticleSalesForecastComponent,
    RecipeCardFinderComponent
  ],
  exports: [
    AddEditArticleModalComponent,
    StoreStocksCorrectionsModalComponent,
    ChangeMhdModalComponent,
    RecipeCardFinderComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    NzButtonModule,
    NzIconModule,
    NzModalModule,
    NzWaveModule,
    NzCheckboxModule,
    NzFormModule,
    NzGridModule,
    NzInputModule,
    NzListModule,
    NzSelectModule,
    NzSpinModule,
    NzTableModule,
    NzTabsModule,
    ReactiveFormsModule,
    UiModule,
    CoreModule,
    NzTooltipDirective,
    NzStatisticComponent,
    ArticleLabelsModule,
    LabelsPrinterCoreModule,
    NzCardModule,
    NzEmptyModule,
    NzTagModule,
    NzRadioModule,
    NzAlertModule,
    BaseChartDirective
  ],
  providers: [
    provideCharts(withDefaultRegisterables())
  ]
})
export class SharedModule { }
